import React from 'react';
export const Error = () => {
    return (React.createElement("div", { id: "error-page", style: {
            alignItems: 'center',
            textAlign: 'center',
            padding: '3%',
        } },
        React.createElement("h1", null, "Oops!"),
        React.createElement("p", null, "Sorry, an unexpected error has occurred.")));
};
//# sourceMappingURL=Error.js.map